import { render, staticRenderFns } from "./TravelType.vue?vue&type=template&id=f2b5a972&"
import script from "./TravelType.vue?vue&type=script&lang=js&"
export * from "./TravelType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports